var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 21.5625C5.64434 21.5625 5.53797 21.5388 5.43806 21.4913C5.19009 21.3713 5.03125 21.1205 5.03125 20.8438V17.25H2.875C1.68619 17.25 0.71875 16.2826 0.71875 15.0938V3.59375C0.71875 2.40494 1.68619 1.4375 2.875 1.4375H20.125C21.3138 1.4375 22.2812 2.40494 22.2812 3.59375V15.0938C22.2812 16.2826 21.3138 17.25 20.125 17.25H11.3929L6.19922 21.4051C6.06913 21.5093 5.91028 21.5625 5.75 21.5625ZM2.875 2.875C2.47825 2.875 2.15625 3.19772 2.15625 3.59375V15.0938C2.15625 15.4898 2.47825 15.8125 2.875 15.8125H5.75C6.14747 15.8125 6.46875 16.1338 6.46875 16.5312V19.3487L10.6914 15.9699C10.8193 15.8678 10.9768 15.8125 11.1406 15.8125H20.125C20.5217 15.8125 20.8438 15.4898 20.8438 15.0938V3.59375C20.8438 3.19772 20.5217 2.875 20.125 2.875H2.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.625H5.75C5.35253 8.625 5.03125 8.303 5.03125 7.90625C5.03125 7.5095 5.35253 7.1875 5.75 7.1875H17.25C17.6475 7.1875 17.9688 7.5095 17.9688 7.90625C17.9688 8.303 17.6475 8.625 17.25 8.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5H5.75C5.35253 11.5 5.03125 11.178 5.03125 10.7812C5.03125 10.3845 5.35253 10.0625 5.75 10.0625H11.5C11.8975 10.0625 12.2188 10.3845 12.2188 10.7812C12.2188 11.178 11.8975 11.5 11.5 11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallchat);
export default __webpack_public_path__ + "static/media/smallchat.f056a4936c4bcd41687c5c1d41749edd.svg";
export { ForwardRef as ReactComponent };